// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Mg","zenCrossSiteLabel":"Ng","vrsnlCrossSiteLabel":"Og"};